import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";

export default function PublicNewsletter() {
  const { token } = useParams();
  const [searchParams] = useSearchParams();
  const [html, setHtml] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!token) return;
    const rid = searchParams.get("rid");
    const t = searchParams.get("t");
    let url = `/api/public/newsletter/${encodeURIComponent(token)}`;
    if (rid && t) {
      url += `?rid=${encodeURIComponent(rid)}&t=${encodeURIComponent(t)}`;
    }
    fetch(url)
      .then((res) => {
        if (!res.ok) throw new Error(res.status === 404 ? "not_found" : "error");
        return res.text();
      })
      .then(setHtml)
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  }, [token, searchParams]);

  if (loading) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh", fontFamily: "sans-serif", color: "#666" }}>
        Loading…
      </div>
    );
  }

  if (error || !html) {
    return (
      <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", height: "100vh", fontFamily: "sans-serif", color: "#666", gap: 8 }}>
        <h2 style={{ margin: 0 }}>Newsletter not found</h2>
        <p>This newsletter is no longer available.</p>
      </div>
    );
  }

  return (
    <iframe
      srcDoc={html}
      title="Newsletter"
      style={{ width: "100%", height: "100vh", border: "none" }}
      sandbox="allow-same-origin allow-popups"
    />
  );
}
